import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

function TutorField({ k, label, required, value, onChange }) {
  return (
    <div>
      <label className="text-xs font-semibold mb-1 block">{label}{required && " *"}</label>
      <input
        type="text"
        value={value}
        onChange={onChange}
        required={required}
        data-testid={`tutor-${k}`}
        className="w-full rounded-lg border border-neutral-300 bg-white px-3 h-10 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
      />
    </div>
  );
}

export default function TutorDialog({ open, onClose, onConfirm }) {
  const [tutor, setTutor] = useState({
    nombre: "",
    dni: "",
    direccion: "",
    cp: "",
    localidad: "",
    provincia: "",
  });

  useEffect(() => {
    if (open) {
      setTutor({ nombre: "", dni: "", direccion: "", cp: "", localidad: "", provincia: "" });
    }
  }, [open]);

  const submit = (e) => {
    e.preventDefault();
    if (!tutor.nombre.trim() || !tutor.dni.trim()) return;
    onConfirm(tutor);
  };

  const field = (k, label, required) => (
    <TutorField
      k={k}
      label={label}
      required={required}
      value={tutor[k]}
      onChange={(e) => setTutor({ ...tutor, [k]: e.target.value })}
    />
  );

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="tutor-dialog">
        <DialogHeader>
          <DialogTitle>Datos del tutor / representante legal</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {field("nombre", "Nombre completo del tutor", true)}
          {field("dni", "DNI / NIE / Pasaporte", true)}
          {field("direccion", "Dirección")}
          <div className="grid grid-cols-3 gap-3">
            {field("cp", "C.P.")}
            {field("localidad", "Localidad")}
            {field("provincia", "Provincia")}
          </div>
          <DialogFooter className="gap-2">
            <button type="button" onClick={onClose} className="btn-secondary">Cancelar</button>
            <button type="submit" className="btn-primary" data-testid="tutor-generate">Generar PDF</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
